import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Radio } from 'SRC/ui/FormElements/Radio'

export const Gender = () => {
  const { t } = useTranslation('common')

  const options = [
    {
      label: t('gender_male'),
      value: 'm',
      className: 'muski-pol-radio'
    },
    {
      label: t('gender_female'),
      value: 'f',
      className: 'zenski-pol-radio'
    }
  ]

  return (
    <div className='form-pol'>
      <label>{t('Pol')}: <span className='required'>*</span>
        <span className='lead-label'>{t('gender_lead')}</span>
      </label>
      <Radio name='gender' options={options} />
    </div>
  )
}

